import $ from "jquery";
import { useEffect, useRef, useState } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import OutsideClickHandler from "react-outside-click-handler";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import commonClient from "../../../apis/commonClient";
import AppMessage from "@cleanup/components/AppMessage";
import IcomoonIcon from "@icons/IcomoonIcon";
import SntRefreshIcon from "@icons/SntRefreshIcon";
import SntSearchIcon from "@icons/SntSearchIcon";
import SntLink from "../../../components/ReactBootstrap/SntLink";
import moment from "../../../constants/SensolusMoment";
import * as actions from "../../../redux/actions";
import SearchInput from "../SearchPanel/SearchInput";
import SearchPanel from "../SearchPanel/SearchPanel";
import ProfileDropdownTitle from "./ProfileDropdownTitle";
import SntQuestionIcon from "@icons/SntQuestionIcon";

import Logo40Icon from "@images/logo40-40.png";
import SntAnnouncementscon from "@icons/SntAnnouncementscon";
import SntPersonalSettingsIcon from "@icons/SntPersonalSettingsIcon";
import FavoritesDropdown from "../../PageHeader/FavoritesDropdown";
import AccountSwitchDialog from "../../../components/AccountSwitchDialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useFavorites } from "../../../contexts/FavoritesContext";
import { useWebSocket } from "../../../contexts/WebSocketContext";

const Styles = styled.div`
  .login-info .dropdown-menu {
    right: 0;
    left: auto;
  }

  .login-info > .dropdown-toggle {
    padding: 0px;
    margin-top: -2px;
    color: rgba(var(--bs-sensolus-rgb), var(--bs-text-opacity)) !important;
  }

  .git-dropdown .dropdown-menu {
    top: 48px;
    left: -150px;
    display: grid;
  }

  .git-dropdown .dropdown-menu .dropdown-item {
    display: grid;
  }

  .nav-item:hover {
    background-color: #e9ecef;
  }

  .nav-item.none-hover:hover {
    background-color: transparent;
  }
`;

const Header = ({ reloadPage }) => {
  let header = useRef();
  let appMessageWraperRef = useRef();

  const [gitInfo, setGitInfo] = useState({
    gitBranch: "",
    gitBuildTime: "",
    gitBuildVersion: "",
    gitCommitId: "",
    gitCommitTime: "",
    gitDirty: false,
  });

  const history = useHistory();
  const dispatch = useDispatch();
  const language = useSelector((state) => state.language);
  const loginInfo = useSelector((state) => state.user);
  const { newNotificationsCount } = useSelector(
    (state) => state.all,
    shallowEqual
  );
  let { permissionsMap, buildVersion, organisation } = loginInfo;

  const { isMobile } = useSelector((state) => state.all);
  const { reloadAllFavorites } = useFavorites();
  const { disconnect, isConnected } = useWebSocket();

  const [searchInput, setSearchInput] = useState(null);
  const [showAccountSwitchDialog, setShowAccountSwitchDialog] = useState(false);

  useEffect(() => {
    if (permissionsMap.SYSTEM_ADMIN_VIEW) {
      commonClient.getBuildInfor().then(
        ({ data }) => {
          setGitInfo(data);
        },
        (err) => {
          console.log("Error when getting git system info", err);
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logoutClick = (e) => {
    e.preventDefault();

    // Disconnect WebSocket before logout
    if (isConnected) {
      console.log("Disconnecting WebSocket before logout...");
      disconnect();
    }

    history.push("/logout");
  };

  const helpIconClick = (e) => {
    e.preventDefault();
    $("#help-side-info-panel").show();
  };

  useEffect(() => {
    let height = $(appMessageWraperRef).outerHeight() + 50;

    $(header.current).css({ height: height + "px" });
    $("#sidebar").css({ top: height + "px" });
  });

  const renderPlatformSubscription = () => {
    if (organisation) {
      let _link = "#",
        _platformPlanText =
          language[
            "platformplan_" +
              organisation.platformSubscription.basePlan.key +
              "_name"
          ],
        _cursor = "default";
      if (permissionsMap.ORGANIZATION_VIEW) {
        _link = `/organization_update?type=edit&id=${organisation.id}&tabActive=enabled_product_plan_tab`;
        _cursor = "pointer";
      }

      if (organisation.platformSubscription.trial) {
        let _now = moment();
        let _days =
          moment(organisation.platformSubscription.tillDate).diff(
            _now,
            "days"
          ) + 1;
        _platformPlanText += ` TRIAL (${_days} DAYS LEFT)`;
      }

      return (
        <>
          {_platformPlanText && (
            <div id="trial-header">
              <SntLink
                className="text-sensolus fw-bold"
                to={_link}
                style={{
                  textTransform: "uppercase",
                  cursor: _cursor,
                  marginLeft: 264,
                }}
              >
                {_platformPlanText}
              </SntLink>
            </div>
          )}
        </>
      );
    }
  };

  const [showSearchPanel, setShowSearchPanel] = useState(false);

  return (
    <div
      style={{
        zIndex: 1003,
      }}
      id="header"
      className="snt-header"
      ref={header}
    >
      <>
        <div ref={(el) => (appMessageWraperRef = el)}>
          <AppMessage />
        </div>

        <Styles>
          <Navbar bg="light" className="mb-3 text-sensolus">
            <Nav.Item
              className="sidebar-menu-icon d-block d-md-none"
              title={language.menu_key}
              onClick={(e) => {
                e.preventDefault();
                dispatch(actions.setShowCanvasMenu((pre) => !pre));
              }}
              role="button"
              style={{ width: 50, height: 49, position: "relative" }}
              to="/#"
            >
              <div className="position-absolute top-50 start-50 translate-middle">
                <IcomoonIcon icon="menu" size="24"></IcomoonIcon>
              </div>
            </Nav.Item>

            <div className="header-info d-none d-lg-block">
              <div style={{ alignItems: "center", display: "flex" }}>
                {renderPlatformSubscription()}
              </div>
            </div>

            {isMobile && loginInfo.custumInfo === undefined && (
              <Nav.Item className="ms-1">
                <img src={Logo40Icon} alt={"Logo"} />
              </Nav.Item>
            )}

            <Nav
              className="justify-content-end flex-grow-1"
              style={{ alignItems: "center" }}
            >
              <Nav.Item
                className={`align-items-center ${!isMobile && "none-hover"}`}
                style={{ padding: "0.5rem", fontSize: 24, height: 49 }}
              >
                {isMobile ? (
                  <SntSearchIcon
                    size={24}
                    role="button"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setShowSearchPanel &&
                        setShowSearchPanel(!showSearchPanel);
                    }}
                  />
                ) : (
                  <div style={{ position: "relative" }}>
                    <SearchInput
                      onChange={(e) => setSearchInput(e)}
                      setShowSearchPanel={(e) => setShowSearchPanel(e)}
                      id="searchInputId"
                      language={language}
                    />
                  </div>
                )}
                <div
                  className={`background-black snt-background-black ${
                    showSearchPanel ? "visible" : "none"
                  }`}
                />
                <OutsideClickHandler
                  onOutsideClick={(e) => {
                    showSearchPanel &&
                      e.target.id !== "searchInputId" &&
                      setShowSearchPanel(false);
                  }}
                >
                  {showSearchPanel ? (
                    <SearchPanel
                      searchText={searchInput}
                      closePopup={() => setShowSearchPanel(false)}
                      openPopup={() => setShowSearchPanel(true)}
                    />
                  ) : (
                    ""
                  )}
                </OutsideClickHandler>
              </Nav.Item>

              <FavoritesDropdown />

              <Nav.Item
                title={language.header_refresh_title_key}
                onClick={(ev) => {
                  ev.preventDefault();
                  reloadPage && reloadPage();
                  reloadAllFavorites && reloadAllFavorites();
                }}
                role="button"
                style={{ padding: "0.5rem", fontSize: 24, height: 49 }}
                className="d-flex justify-content-center align-items-center"
                to="/#"
              >
                <SntRefreshIcon size={24} role="button" />
              </Nav.Item>

              <Nav.Item
                title={language.help_key}
                onClick={helpIconClick}
                role="button"
                style={{ padding: "0.5rem", fontSize: 24, height: 49 }}
                className="d-flex justify-content-center align-items-center"
                to="/#"
              >
                <SntQuestionIcon size={24} role="button" />
              </Nav.Item>
              <Nav.Item
                title={language.notifications_key}
                onClick={() => {
                  dispatch(actions.setShowGlobalNotification(true));
                }}
                role="button"
                style={{
                  padding: "0.5rem",
                  fontSize: 24,
                  height: 49,
                }}
                className="d-flex justify-content-center align-items-center"
                to="/#"
              >
                <span className="position-relative">
                  {newNotificationsCount ? (
                    <span
                      className="position-absolute translate-middle badge rounded-pill bg-danger"
                      style={{ fontSize: 10, top: -12, left: 20 }}
                    >
                      {newNotificationsCount}
                    </span>
                  ) : (
                    ""
                  )}
                </span>
                <SntAnnouncementscon size={24} role="button" />
              </Nav.Item>
              <NavDropdown
                className={`d-flex justify-content-center align-items-center no-caret login-info ${
                  isMobile ? "" : "me-3"
                }`}
                style={{ padding: "0.5rem", height: "49px", fontSize: 24 }}
                title={<ProfileDropdownTitle loginInfo={loginInfo} />}
              >
                <div>
                  <NavDropdown.Item
                    bsPrefix="dropdown-item nav-link"
                    onClick={() => {
                      const currentPathWithQuery =
                        window.location.pathname + window.location.search;

                      // Save it to sessionStorage
                      sessionStorage.setItem(
                        "PROFILE_PREV_PATH",
                        currentPathWithQuery
                      );

                      history.push("/profile");
                    }}
                  >
                    <span className="me-2">
                      <SntPersonalSettingsIcon />
                    </span>
                    {language.personal_settings_key}
                  </NavDropdown.Item>
                  {loginInfo.availableAccounts &&
                    loginInfo.availableAccounts.length > 1 && (
                      <NavDropdown.Item
                        bsPrefix="dropdown-item nav-link"
                        onClick={() => setShowAccountSwitchDialog(true)}
                      >
                        <FontAwesomeIcon
                          icon={faArrowRightArrowLeft}
                          className="me-2"
                        />
                        {language.switch_account_key}
                      </NavDropdown.Item>
                    )}
                  <NavDropdown.Item
                    bsPrefix="dropdown-item nav-link"
                    onClick={logoutClick}
                  >
                    <IcomoonIcon
                      icon="exit"
                      size="16"
                      className="me-2"
                    ></IcomoonIcon>
                    {language.header_logout_key}
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  {permissionsMap["SYSTEM_ADMIN_VIEW"] ? (
                    <NavDropdown
                      bsPrefix="dropdown-item nav-link"
                      className="git-dropdown"
                      title={
                        <>
                          <IcomoonIcon
                            icon="info"
                            className="me-2"
                          ></IcomoonIcon>
                          {"Version " + gitInfo.gitBuildVersion}
                        </>
                      }
                    >
                      <NavDropdown.Item>
                        <b>Git Branch:</b> {gitInfo.gitBranch}
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <b>Build Version:</b> {gitInfo.gitBuildVersion}
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <b>Git Branch:</b> {gitInfo.gitBranch}
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <b>Git Branch:</b> {gitInfo.gitBranch}
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <b>Build Time:</b> {gitInfo.gitBuildTime}
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <b>Commit ID:</b> {gitInfo.gitCommitId}
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <b>Commit Time:</b> {gitInfo.gitCommitTime}
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <b>Git Status:</b>{" "}
                        {gitInfo.gitDirty ? "dirty" : "clean"}
                      </NavDropdown.Item>
                    </NavDropdown>
                  ) : (
                    <NavDropdown.Item bsPrefix="nav-item nav-link">
                      <IcomoonIcon icon="info" className="me-2"></IcomoonIcon>
                      {"Version " + buildVersion}
                    </NavDropdown.Item>
                  )}
                </div>
              </NavDropdown>
            </Nav>
          </Navbar>
        </Styles>
      </>
      <AccountSwitchDialog
        show={showAccountSwitchDialog}
        onHide={() => setShowAccountSwitchDialog(false)}
        currentUser={loginInfo}
        language={language}
        openedFrom="header"
      />
    </div>
  );
};

export default Header;
